import React, { useState } from "react";

// @mui/material components

// @mui/icons-material
import Receipt from "@mui/icons-material/Receipt";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import Visibility from "@mui/icons-material/Visibility";

// @mui/material components


import CircularProgress from '@mui/material/CircularProgress';

// core components
import OthelloGrid from '../../componentsothello/OthelloGrid.jsx';
import OthelloModalBase from '../../componentsothello/OthelloModalBase.jsx';
import Pedido from './Pedido.js';
import EstadoPedido from './EstadoPedido.js';

import { TipoOthelloFieldGrid, DataStateModal, ModoModal, MessageOthelloBoxButtons, TipoEntregaCombo, DataStatePage, EstadosPedido, DialogOthelloResult} from "../../othelloConstantes.jsx";

import Grid from "@mui/material/Grid";
import OthelloTituloPanelData from "../../componentsothello/OthelloTituloPanelData.jsx";

export default function Pedidos({ ...props })
{
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [datapedidos, setdatapedidos] = React.useState(null);

    const [stateModal, setstateModal] = React.useState(DataStateModal.dsClosed);
    const [itemmodal, setitemmodal] = React.useState(null);
    const [modomodal, setmodomodal] = React.useState(null);
    const [nombretienda, setnombretienda] = React.useState("");  

    React.useEffect(() => {

        setLoading(false);
        getDataNombreTienda();
        getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataNombreTienda = () => {
        fetch('api/Data/GetNombreTiendaSelected')
            .then(response => response.json())
            .then(data =>
            {
                setnombretienda(data.nombre);
            });
    }

    const getDataPage = () => {

        fetch('api/Data/GetPedidos')
            .then(response => response.json())
            .then(data => {
                setdatapedidos(data);
            });
    }

    const onclickColumna = (valor, field) => {

        if (field != null) {
            if (field == "tramitado") {
                setstateModal(DataStateModal.dsOpen);
                setitemmodal(valor);
                setmodomodal(field);
            }
            else if (field == "ver") {
                setstateModal(DataStateModal.dsOpen);
                setitemmodal(valor);
                setmodomodal(field);
            }                
        }
    }


    const othelloModalResul = (modo, result, valor) => {

        if (modomodal == "tramitado" && result == 1 /*DialogOthelloResult.Ok*/) {

            setstateModal(DataStateModal.dsClosed);
            setitemmodal(null);
            setmodomodal(null);

            getDataPage();
        }
        else {
            setstateModal(DataStateModal.dsClosed);
            setitemmodal(null);
            setmodomodal(null);
        }            
    }

    function renderModalPedido(item, modo) {
        if (item != null) {
            if (modo == "tramitado") {
                return (<EstadoPedido idpedido={item.id_Pedido} idusuario={item.id_Usuario} estado={item.estado} onCloseResulModal={othelloModalResul} />)
            }
            else if (modo == "ver") {
                return (<OthelloModalBase titulo="Pedido" modo={ModoModal.SinDefinir} open={stateModal} onCloseResulModal={othelloModalResul} botones={MessageOthelloBoxButtons.OK} >
                    <Pedido idpedido={item.id_Pedido} />
                </OthelloModalBase>)
            }
        }
        else
            return "";
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA


    function renderSearch(datos) {

        let valorescabe = ["", "", "Pedido", "Fecha Pedido", "Hora Pedido", "Estado", "Entrega", "F. Entrega", "Cliente", "Telefono", "Total"];

        //Generamos los valores de cada una de las lineas de grid       
        let valoreshow = ["tramitado", "ver", "id_Pedido", "fechaPedidoString", "horaPedidoString", "estado", "tipoEntrega", "fechaEntregaString", "nombreApellidos", "telefono", "total"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tipoEntrega", items: TipoEntregaCombo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "estado", items: EstadosPedido });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloCurrency, fieldname: "total" });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "tramitado", icon: CheckCircleOutlined, onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "ver", icon: Visibility, onclick: onclickColumna });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={valorescabe} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={15} />);
    }


    let busqueda = loading ? <p><CircularProgress  color="secondary" /></p>
        : renderSearch(datapedidos);

    let modal = "";

    if (stateModal != DataStateModal.dsClosed)
        modal = renderModalPedido(itemmodal, modomodal);
   
    let namefinal = nombretienda != null ? nombretienda : "";
    let pedidosfinal = "Pedidos" + namefinal;

    return (
        <Grid container mt={2}>
            {modal}
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData titulo={pedidosfinal} margentop={0}>
                            <Grid container>
                                <Grid item xs={12} >
                                    {busqueda}
                                </Grid>
                            </Grid>                  
                    </OthelloTituloPanelData>
                </Grid>
            </Grid>
        </Grid>
    );
}